export function totalPrice(items) {
    return items.reduce((total, item) => {
        return total + (item.treatment.price || 0) * item.quantity;
    }, 0);
}
export function priceStyle(items) {
    const colorIdx = items.findIndex((el) => el.color);
    return {
        'border-bottom': `3px solid ${items[colorIdx].color}`
    };
}
